import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import { SiteConfig } from '../shared';

class HeaderController implements ng.IComponentController {
   static $inject = ['config', 'gettextCatalog'];

   constructor(private config:SiteConfig, private gettextCatalog:nggt.gettextCatalog) { }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get headerImage():string|undefined {
      if (this.config.settings.uploads['headerImage']) {
         return this.config.settings.uploads['headerImage'][this.language];
      }
   }
}

ng.module('selfReg').component('header', {
   templateUrl: require('./header.html'),
   controller: HeaderController
});
